// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { createPortal } from "react-dom";
// import {
//   IconCalendarWeek,
//   IconChevronLeft,
//   IconChevronRight,
//   IconChevronDown,
//   IconCheck,
//   IconRefresh,
// } from "@tabler/icons-react";
// import { useLanguage } from "../context/LanguageContext";

// interface PremiumDateRangePickerProps {
//   title?: string;
//   startDate?: string;
//   endDate?: string;
//   startDateError?: any;
//   endDateError?: any;
//   disabled?: boolean;
//   isEditable?: boolean;
//   onChangeRange?: (range: { startDate: string; endDate: string }) => void;
//   className?: string;
//   placeholder?: string;
//   align?: "left" | "right";
// }

// const MONTH_NAMES = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

// const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// const ALL_YEARS = Array.from({ length: 201 }, (_, i) => 1900 + i);

// interface CustomSelectProps {
//   value: number | string;
//   options: { label: string; value: number | string }[];
//   onChange: (val: any) => void;
//   className?: string;
//   buttonClassName?: string;
//   menuClassName?: string;
// }

// const CustomSelect: React.FC<CustomSelectProps> = ({
//   value,
//   options,
//   onChange,
//   className = "",
//   buttonClassName = "",
//   menuClassName = "",
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef<HTMLDivElement>(null);
//   const listRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(e.target as Node)
//       ) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (isOpen && listRef.current) {
//       const selectedEl = listRef.current.querySelector(
//         "[data-selected='true']"
//       );
//       if (selectedEl) {
//         selectedEl.scrollIntoView({ block: "center" });
//       }
//     }
//   }, [isOpen]);

//   const selectedOption =
//     options.find((opt) => String(opt.value) === String(value)) || options[0];

//   return (
//     <div className={`relative inline-block ${className}`} ref={dropdownRef}>
//       <button
//         type="button"
//         onClick={() => setIsOpen(!isOpen)}
//         className={`flex items-center justify-between gap-1 text-xs font-bold bg-yellow-50/80 border border-gray-200 rounded-lg px-2 py-1 outline-none hover:border-[#FBD037] cursor-pointer text-[#212121] transition-all w-full ${buttonClassName}`}
//       >
//         <span className="truncate">{selectedOption?.label}</span>
//         <IconChevronDown size={14} className="text-gray-500 shrink-0" />
//       </button>

//       {isOpen && (
//         <div
//           ref={listRef}
//           className={`absolute top-full left-0 mt-1 z-[300] min-w-full w-max max-h-[200px] overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-xl p-1 animate-in fade-in slide-in-from-top-1 [scrollbar-width:thin] [scrollbar-color:#FBD037_#FEF3C7] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-[#FBD037] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-yellow-50 ${menuClassName}`}
//         >
//           {options.map((opt) => {
//             const isSelected = String(opt.value) === String(value);
//             return (
//               <button
//                 key={String(opt.value)}
//                 type="button"
//                 data-selected={isSelected}
//                 onClick={() => {
//                   onChange(opt.value);
//                   setIsOpen(false);
//                 }}
//                 className={`w-full text-center whitespace-nowrap px-2 py-1 text-[11px] font-bold rounded-md transition-all block ${
//                   isSelected
//                     ? "bg-[#FBD037] text-[#212121] shadow-xs"
//                     : "hover:bg-yellow-100/70 text-[#212121]"
//                 }`}
//               >
//                 {opt.label}
//               </button>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// const formatYYYYMMDD = (y: number, m: number, d: number) => {
//   const mm = String(m + 1).padStart(2, "0");
//   const dd = String(d).padStart(2, "0");
//   return `${y}-${mm}-${dd}`;
// };

// const calculateDays = (startStr?: string, endStr?: string) => {
//   if (!startStr || !endStr) return 0;
//   const start = new Date(startStr);
//   const end = new Date(endStr);
//   if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;
//   const diffTime = end.getTime() - start.getTime();
//   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
//   return diffDays > 0 ? diffDays : 0;
// };

// const formatDateDisplay = (dateStr?: string) => {
//   if (!dateStr) return "--";
//   const d = new Date(dateStr);
//   if (isNaN(d.getTime())) return dateStr;
//   return d.toLocaleDateString("en-US", {
//     month: "short",
//     day: "2-digit",
//     year: "numeric",
//   });
// };

// const PremiumDateRangePicker: React.FC<PremiumDateRangePickerProps> = ({
//   title = "Start & Exp Date",
//   startDate: propStartDate = "",
//   endDate: propEndDate = "",
//   startDateError,
//   endDateError,
//   disabled = false,
//   isEditable = true,
//   onChangeRange,
//   className = "",
//   placeholder = "YYYY-MM-DD",
//   align = "left",
// }) => {
//   const { t } = useLanguage();
//   const [open, setOpen] = useState(false);
//   const [tempStart, setTempStart] = useState(propStartDate);
//   const [tempEnd, setTempEnd] = useState(propEndDate);
//   const [activeTarget, setActiveTarget] = useState<"start" | "end">("start");

//   const ref = useRef<HTMLDivElement>(null);

//   const initialDateObj = tempStart ? new Date(tempStart) : new Date();
//   const validInitialDate = isNaN(initialDateObj.getTime())
//     ? new Date()
//     : initialDateObj;

//   const [currentYear, setCurrentYear] = useState<number>(
//     validInitialDate.getFullYear()
//   );
//   const [currentMonth, setCurrentMonth] = useState<number>(
//     validInitialDate.getMonth()
//   );

//   // Sync with props
//   useEffect(() => {
//     setTempStart(propStartDate);
//     setTempEnd(propEndDate);
//     if (propStartDate) {
//       const d = new Date(propStartDate);
//       if (!isNaN(d.getTime())) {
//         setCurrentYear(d.getFullYear());
//         setCurrentMonth(d.getMonth());
//       }
//     }
//   }, [propStartDate, propEndDate]);

//   // Close dropdown on outside click
//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (ref.current && !ref.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleDaySelect = (dayNum: number) => {
//     const selectedDateStr = formatYYYYMMDD(currentYear, currentMonth, dayNum);
//     if (!tempStart || activeTarget === "start") {
//       setTempStart(selectedDateStr);
//       if (tempEnd && selectedDateStr > tempEnd) {
//         setTempEnd("");
//       }
//       setActiveTarget("end");
//     } else {
//       if (selectedDateStr < tempStart) {
//         setTempStart(selectedDateStr);
//         setTempEnd("");
//         setActiveTarget("end");
//       } else {
//         setTempEnd(selectedDateStr);
//       }
//     }
//   };

//   const handleApply = () => {
//     onChangeRange?.({ startDate: tempStart, endDate: tempEnd });
//     setOpen(false);
//   };

//   const handlePreset = (preset: "today" | "last7" | "thisMonth" | "clear") => {
//     const now = new Date();
//     if (preset === "today") {
//       const todayStr = formatYYYYMMDD(
//         now.getFullYear(),
//         now.getMonth(),
//         now.getDate()
//       );
//       setTempStart(todayStr);
//       setTempEnd(todayStr);
//     } else if (preset === "last7") {
//       const endStr = formatYYYYMMDD(
//         now.getFullYear(),
//         now.getMonth(),
//         now.getDate()
//       );
//       const past = new Date(now);
//       past.setDate(past.getDate() - 6);
//       const startStr = formatYYYYMMDD(
//         past.getFullYear(),
//         past.getMonth(),
//         past.getDate()
//       );
//       setTempStart(startStr);
//       setTempEnd(endStr);
//     } else if (preset === "thisMonth") {
//       const startStr = formatYYYYMMDD(now.getFullYear(), now.getMonth(), 1);
//       const lastDay = new Date(
//         now.getFullYear(),
//         now.getMonth() + 1,
//         0
//       ).getDate();
//       const endStr = formatYYYYMMDD(now.getFullYear(), now.getMonth(), lastDay);
//       setTempStart(startStr);
//       setTempEnd(endStr);
//     } else if (preset === "clear") {
//       setTempStart("");
//       setTempEnd("");
//       setActiveTarget("start");
//       setCurrentYear(now.getFullYear());
//       setCurrentMonth(now.getMonth());
//       onChangeRange?.({ startDate: "", endDate: "" });
//     }
//   };

//   const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
//   const firstDayIndex = new Date(currentYear, currentMonth, 1).getDay();
//   const prevMonthDays = new Date(currentYear, currentMonth, 0).getDate();

//   const handlePrevMonth = () => {
//     if (currentMonth === 0) {
//       setCurrentMonth(11);
//       setCurrentYear(currentYear - 1);
//     } else {
//       setCurrentMonth(currentMonth - 1);
//     }
//   };

//   const handleNextMonth = () => {
//     if (currentMonth === 11) {
//       setCurrentMonth(0);
//       setCurrentYear(currentYear + 1);
//     } else {
//       setCurrentMonth(currentMonth + 1);
//     }
//   };

//   const todayStr = formatYYYYMMDD(
//     new Date().getFullYear(),
//     new Date().getMonth(),
//     new Date().getDate()
//   );

//   const totalDays = calculateDays(tempStart, tempEnd);

//   return (
//     <div className={`relative w-full ${className}`} ref={ref}>
//       {/* ── Combined Single Trigger Input Bar for Start & Exp Date ── */}
//       <div
//         onClick={() => isEditable && !disabled && setOpen(!open)}
//         className={`relative w-full rounded-lg py-4 px-3.5 outline-none text-xs bg-yellow-50 border transition-all duration-200 cursor-pointer flex items-center justify-between gap-2 text-[#1E1E1E] ${open ? "border-[#FBD037] ring-2 ring-[#FBD037]/30" : startDateError || endDateError ? "border-red-500" : "border-[#FBD037]"
//         } ${!isEditable || disabled ? "opacity-70 bg-gray-100 cursor-not-allowed" : ""}`}
//       >
//         <div className="flex items-center justify-around w-full text-xs text-[#1E1E1E] whitespace-nowrap overflow-hidden">
//           {/* Start Date */}
//           <div className="flex items-center gap-1.5 font-medium whitespace-nowrap">
//             <span>{propStartDate || placeholder}</span>
//             <IconCalendarWeek size={15} className="text-[#212121] shrink-0" />
//           </div>

//           {/* Divider */}
//           <span className="h-4 w-[1px] bg-gray-300 mx-2 inline-block shrink-0" />

//           {/* Exp Date */}
//           <div className="flex items-center gap-1.5 font-medium whitespace-nowrap">
//             <span>{propEndDate || placeholder}</span>
//             <IconCalendarWeek size={15} className="text-[#212121] shrink-0" />
//           </div>
//         </div>

//         {/* Animated Floating Label */}
//         {title && (
//           <label
//             className={`absolute pointer-events-none transition-all duration-200 ease-in-out select-none rounded-md -top-2.5 left-2.5 text-[11px] font-semibold bg-yellow-50 z-10 px-1.5 ${
//               startDateError || endDateError
//                 ? "!text-red-500"
//                 : "!text-black font-medium"
//             }`}
//           >
//             {title}
//           </label>
//         )}
//       </div>

//       {/* ── COMPACT PREMIUM DATE RANGE UI DROPDOWN ── */}
//       {open && isEditable && !disabled && (
//         <div
//           className={`absolute z-[250] top-full mt-1.5 ${
//             align === "right" ? "right-0" : "left-0"
//           } bg-white rounded-2xl border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.18)] p-2.5 w-[410px] animate-in fade-in slide-in-from-top-2 select-none`}
//         >
//           {/* Top Presets & Header Action Bar */}
//           <div className="flex items-center justify-between gap-1 pb-2 mb-2 border-b border-gray-100">
//             <div className="flex items-center gap-1">
//               <button
//                 type="button"
//                 onClick={() => handlePreset("today")}
//                 className="px-2 py-0.5 rounded-md border border-gray-200 bg-white hover:border-[#FBD037] hover:bg-yellow-50 text-[10px] font-bold text-gray-700 transition-all cursor-pointer whitespace-nowrap"
//               >
//                 Today
//               </button>
//               <button
//                 type="button"
//                 onClick={() => handlePreset("last7")}
//                 className="px-2 py-0.5 rounded-md border border-gray-200 bg-white hover:border-[#FBD037] hover:bg-yellow-50 text-[10px] font-bold text-gray-700 transition-all cursor-pointer whitespace-nowrap"
//               >
//                 Last 7 Days
//               </button>
//               <button
//                 type="button"
//                 onClick={() => handlePreset("thisMonth")}
//                 className="px-2 py-0.5 rounded-md border border-gray-200 bg-white hover:border-[#FBD037] hover:bg-yellow-50 text-[10px] font-bold text-gray-700 transition-all cursor-pointer whitespace-nowrap"
//               >
//                 This Month
//               </button>
//               <button
//                 type="button"
//                 onClick={() => handlePreset("clear")}
//                 className="px-1.5 py-0.5 rounded-md border border-gray-200 bg-white hover:border-red-300 hover:bg-red-50 text-[10px] font-bold text-gray-500 hover:text-red-600 transition-all cursor-pointer flex items-center gap-0.5 whitespace-nowrap"
//               >
//                 <IconRefresh size={11} /> Clear
//               </button>
//             </div>

//             <button
//               type="button"
//               onClick={handleApply}
//               className="bg-[#FBD037] hover:bg-yellow-400 text-[#212121] font-extrabold text-[11px] py-1 px-3 rounded-lg shadow-xs active:scale-95 transition-all flex items-center gap-1 cursor-pointer shrink-0"
//             >
//               <IconCheck size={13} /> Apply Range
//             </button>
//           </div>

//           {/* Body: 2-Column Layout (Summary Panel Left + Calendar Right) */}
//           <div className="grid grid-cols-12 gap-2.5 items-stretch">
//             {/* Left Summary Sidebar (SELECTED RANGE) */}
//             <div className="col-span-4 bg-gradient-to-b from-yellow-50/90 to-amber-50/40 rounded-lg p-2 border border-amber-200/50 flex flex-col justify-between items-center text-center">
//               <div className="w-full flex flex-col items-center">
//                 <div className="w-8 h-8 rounded-lg bg-white shadow-xs border border-amber-200/80 flex items-center justify-center text-[#B47814] mb-1.5 mt-0.5">
//                   <IconCalendarWeek size={16} />
//                 </div>
//                 <span className="text-[8px] font-extrabold uppercase tracking-wider text-gray-400 block mb-1.5">
//                   SELECTED RANGE
//                 </span>

//                 {/* Start Date */}
//                 <div
//                   onClick={() => setActiveTarget("start")}
//                   className={`w-full py-1 px-1.5 rounded-lg border transition-all cursor-pointer ${
//                     activeTarget === "start"
//                       ? "bg-white border-[#FBD037] ring-1 ring-[#FBD037]/30 shadow-xs"
//                       : "bg-white/60 border-transparent hover:bg-white"
//                   }`}
//                 >
//                   <span className="text-[7px] font-extrabold uppercase text-gray-400 block leading-tight">
//                     Start Date
//                   </span>
//                   <strong className="text-[11px] font-bold text-[#212121] truncate block leading-tight">
//                     {formatDateDisplay(tempStart)}
//                   </strong>
//                 </div>

//                 {/* Arrow */}
//                 <div className="text-amber-500 font-bold my-0.5 text-[10px]">↓</div>

//                 {/* End Date */}
//                 <div
//                   onClick={() => setActiveTarget("end")}
//                   className={`w-full py-1 px-1.5 rounded-lg border transition-all cursor-pointer ${
//                     activeTarget === "end"
//                       ? "bg-white border-[#FBD037] ring-1 ring-[#FBD037]/30 shadow-xs"
//                       : "bg-white/60 border-transparent hover:bg-white"
//                   }`}
//                 >
//                   <span className="text-[7px] font-extrabold uppercase text-gray-400 block leading-tight">
//                     Exp Date
//                   </span>
//                   <strong className="text-[11px] font-bold text-[#212121] truncate block leading-tight">
//                     {formatDateDisplay(tempEnd)}
//                   </strong>
//                 </div>
//               </div>

//               {/* Total Duration Badge */}
//               <div className="mt-2 pt-1.5 border-t border-amber-200/50 w-full">
//                 <span className="text-[10px] font-extrabold text-[#B47814] bg-white px-2 py-0.5 rounded-full border border-amber-200/80 shadow-2xs inline-block">
//                   {totalDays} Days
//                 </span>
//               </div>
//             </div>

//             {/* Right Calendar Section */}
//             <div className="col-span-8 flex flex-col justify-between">
//               {/* Calendar Month/Year Header (Combined Month & Year in 1 container) */}
//               <div className="flex items-center justify-between pb-1.5 mb-1 border-b border-gray-100 w-full">
//                 <button
//                   type="button"
//                   onClick={handlePrevMonth}
//                   className="p-1 rounded-full text-gray-600 hover:bg-yellow-100/80 hover:text-black transition-all active:scale-95 shrink-0 cursor-pointer"
//                 >
//                   <IconChevronLeft size={15} />
//                 </button>

//                 {/* Single Combined Month & Year Container */}
//                 <div className="flex items-center justify-center bg-white border border-gray-200 rounded-lg px-2 py-0.5 shadow-2xs hover:border-[#FBD037] transition-all">
//                   <CustomSelect
//                     value={currentMonth}
//                     options={MONTH_NAMES.map((mName, idx) => ({
//                       label: mName,
//                       value: idx,
//                     }))}
//                     onChange={(val) => setCurrentMonth(Number(val))}
//                     className="min-w-[70px]"
//                     buttonClassName="border-0 bg-transparent py-0 px-1 text-[11px] font-extrabold text-[#212121] shadow-none"
//                     menuClassName="min-w-[95px]"
//                   />
//                   <span className="text-gray-400 font-bold text-[11px] mx-0.5">•</span>
//                   <CustomSelect
//                     value={currentYear}
//                     options={ALL_YEARS.map((yr) => ({
//                       label: String(yr),
//                       value: yr,
//                     }))}
//                     onChange={(val) => setCurrentYear(Number(val))}
//                     className="min-w-[50px]"
//                     buttonClassName="border-0 bg-transparent py-0 px-1 text-[11px] font-extrabold text-[#212121] shadow-none"
//                     menuClassName="min-w-[62px]"
//                   />
//                 </div>

//                 <button
//                   type="button"
//                   onClick={handleNextMonth}
//                   className="p-1 rounded-full text-gray-600 hover:bg-yellow-100/80 hover:text-black transition-all active:scale-95 shrink-0 cursor-pointer"
//                 >
//                   <IconChevronRight size={15} />
//                 </button>
//               </div>

//               {/* Days of Week */}
//               <div className="grid grid-cols-7 text-center mb-0.5">
//                 {DAYS_OF_WEEK.map((d) => (
//                   <span
//                     key={d}
//                     className="text-[9px] font-bold text-gray-400 uppercase"
//                   >
//                     {d}
//                   </span>
//                 ))}
//               </div>

//               {/* Days Grid with Rounded Pill Range Selection Caps */}
//               <div className="grid grid-cols-7 text-center">
//                 {/* Overflow Previous Month Days */}
//                 {Array.from({ length: firstDayIndex }).map((_, idx) => (
//                   <div
//                     key={`prev-${idx}`}
//                     className="aspect-square flex items-center justify-center text-[11px] text-gray-300 font-light"
//                   >
//                     {prevMonthDays - firstDayIndex + idx + 1}
//                   </div>
//                 ))}

//                 {/* Current Month Days */}
//                 {Array.from({ length: daysInMonth }).map((_, idx) => {
//                   const dayNum = idx + 1;
//                   const dStr = formatYYYYMMDD(
//                     currentYear,
//                     currentMonth,
//                     dayNum
//                   );
//                   const isStart = dStr === tempStart;
//                   const isEnd = dStr === tempEnd;
//                   const isInRange =
//                     tempStart && tempEnd && dStr > tempStart && dStr < tempEnd;
//                   const isToday = dStr === todayStr;

//                   return (
//                     <div
//                       key={dayNum}
//                       className={`py-0.5 ${
//                         isStart && isEnd
//                           ? "bg-transparent"
//                           : isStart
//                           ? "bg-gradient-to-r from-transparent to-yellow-100/90"
//                           : isEnd
//                           ? "bg-gradient-to-l from-transparent to-yellow-100/90"
//                           : isInRange
//                           ? "bg-yellow-100/90"
//                           : "bg-transparent"
//                       }`}
//                     >
//                       <button
//                         type="button"
//                         onClick={() => handleDaySelect(dayNum)}
//                         className={`w-full aspect-square flex items-center justify-center text-[11px] font-bold transition-all duration-150 cursor-pointer ${
//                           isStart && isEnd
//                             ? "bg-[#FBD037] text-[#212121] rounded-full shadow-md scale-105"
//                             : isStart
//                             ? "bg-[#FBD037] text-[#212121] rounded-l-full shadow-md scale-105"
//                             : isEnd
//                             ? "bg-[#FBD037] text-[#212121] rounded-r-full shadow-md scale-105"
//                             : isInRange
//                             ? "bg-yellow-100/90 text-[#212121] rounded-none"
//                             : isToday
//                             ? "border border-[#FBD037] text-slate-900 bg-yellow-50 rounded-full"
//                             : "hover:bg-yellow-100/70 text-[#212121] rounded-full"
//                         }`}
//                       >
//                         {dayNum}
//                       </button>
//                     </div>
//                   );
//                 })}
//               </div>

//               {/* Bottom Quick Row */}
//               <div className="mt-1.5 pt-1 border-t border-gray-100 flex items-center justify-between text-[10px] font-bold text-gray-500" />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PremiumDateRangePicker;


import React, { useState, useRef, useEffect } from "react";
import {
  IconCalendarWeek,
  IconChevronLeft,
  IconChevronRight,
  IconChevronDown,
  IconCheck,
  IconRefresh,
} from "@tabler/icons-react";
import { useLanguage } from "../context/LanguageContext";

interface PremiumDateRangePickerProps {
  title?: string;
  startDate?: string;
  endDate?: string;
  startDateError?: any;
  endDateError?: any;
  disabled?: boolean;
  isEditable?: boolean;
  onChangeRange?: (range: { startDate: string; endDate: string }) => void;
  className?: string;
  placeholder?: string;
  align?: "left" | "right";
}

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const ALL_YEARS = Array.from({ length: 201 }, (_, i) => 1900 + i);

// Custom Select Dropdown
interface CustomSelectProps {
  value: number | string;
  options: { label: string; value: number | string }[];
  onChange: (val: any) => void;
  className?: string;
  buttonClassName?: string;
  menuClassName?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  value,
  options,
  onChange,
  className = "",
  buttonClassName = "",
  menuClassName = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && listRef.current) {
      const selectedEl = listRef.current.querySelector(
        "[data-selected='true']"
      );
      if (selectedEl) {
        selectedEl.scrollIntoView({ block: "center" });
      }
    }
  }, [isOpen]);

  const selectedOption =
    options.find((opt) => String(opt.value) === String(value)) || options[0];

  return (
    <div className={`relative inline-block ${className}`} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-between gap-1 text-[11px] font-bold bg-white border border-gray-200 rounded-lg px-2 py-0.5 outline-none hover:border-[#FBD037] cursor-pointer text-[#212121] transition-all w-full ${buttonClassName}`}
      >
        <span className="truncate">{selectedOption?.label}</span>
        <IconChevronDown size={12} className="text-gray-500 shrink-0" />
      </button>

      {isOpen && (
        <div
          ref={listRef}
          className={`absolute top-full left-0 mt-1 z-[300] min-w-full w-max max-h-[200px] overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-xl p-1 animate-in fade-in slide-in-from-top-1 [scrollbar-width:thin] [scrollbar-color:#FBD037_#FEF3C7] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-[#FBD037] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-yellow-50 ${menuClassName}`}
        >
          {options.map((opt) => {
            const isSelected = String(opt.value) === String(value);
            return (
              <button
                key={String(opt.value)}
                type="button"
                data-selected={isSelected}
                onClick={() => {
                  onChange(opt.value);
                  setIsOpen(false);
                }}
                className={`w-full text-center whitespace-nowrap px-2 py-1 text-[11px] font-bold rounded-md transition-all block ${
                  isSelected
                    ? "bg-[#FBD037] text-[#212121] shadow-xs"
                    : "hover:bg-yellow-100/70 text-[#212121]"
                }`}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

const formatYYYYMMDD = (y: number, m: number, d: number) => {
  const mm = String(m + 1).padStart(2, "0");
  const dd = String(d).padStart(2, "0");
  return `${y}-${mm}-${dd}`;
};

const calculateDays = (startStr?: string, endStr?: string) => {
  if (!startStr || !endStr) return 0;
  const start = new Date(startStr);
  const end = new Date(endStr);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;
  const diffTime = end.getTime() - start.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  return diffDays > 0 ? diffDays : 0;
};

const formatDateDisplay = (dateStr?: string) => {
  if (!dateStr) return "--";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

const PremiumDateRangePicker: React.FC<PremiumDateRangePickerProps> = ({
  title = "Start & Exp Date",
  startDate: propStartDate = "",
  endDate: propEndDate = "",
  startDateError,
  endDateError,
  disabled = false,
  isEditable = true,
  onChangeRange,
  className = "",
  placeholder = "YYYY-MM-DD",
  align = "left",
}) => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [tempStart, setTempStart] = useState(propStartDate);
  const [tempEnd, setTempEnd] = useState(propEndDate);
  const [activeTarget, setActiveTarget] = useState<"start" | "end">("start");

  const ref = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [effectiveAlign, setEffectiveAlign] = useState<"left" | "right">(align);
  const [translateX, setTranslateX] = useState<number>(0);

  useEffect(() => {
    setEffectiveAlign(align);
  }, [align]);

  // Dynamic responsive position detection: shift left if no space on right
  useEffect(() => {
    if (!open) return;

    const checkPosition = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const dropdownEl = dropdownRef.current;
      const dropdownWidth = dropdownEl ? dropdownEl.offsetWidth : 365;

      // Determine alignment: if align is "right", or if left alignment overflows viewport on the right
      let isRight = align === "right";
      if (!isRight) {
        if (rect.left + dropdownWidth > viewportWidth - 12) {
          isRight = true;
        }
      } else {
        // If explicitly "right", but right-align causes left overflow and left-align fits better
        if (rect.right < dropdownWidth && viewportWidth - rect.left > rect.right) {
          isRight = false;
        }
      }

      // Calculate coordinates in viewport space
      const left = isRight ? rect.right - dropdownWidth : rect.left;
      const right = left + dropdownWidth;
      let shift = 0;

      if (right > viewportWidth - 12) {
        shift = viewportWidth - 12 - right;
      } else if (left < 12) {
        shift = 12 - left;
      }

      setEffectiveAlign(isRight ? "right" : "left");
      setTranslateX(shift);
    };

    checkPosition();
    const rafId = requestAnimationFrame(checkPosition);

    window.addEventListener("resize", checkPosition);
    window.addEventListener("scroll", checkPosition, true);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("resize", checkPosition);
      window.removeEventListener("scroll", checkPosition, true);
    };
  }, [open, align]);

  const initialDateObj = tempStart ? new Date(tempStart) : new Date();
  const validInitialDate = isNaN(initialDateObj.getTime())
    ? new Date()
    : initialDateObj;

  const [currentYear, setCurrentYear] = useState<number>(
    validInitialDate.getFullYear()
  );
  const [currentMonth, setCurrentMonth] = useState<number>(
    validInitialDate.getMonth()
  );

  // Sync with props
  useEffect(() => {
    setTempStart(propStartDate);
    setTempEnd(propEndDate);
    if (propStartDate) {
      const d = new Date(propStartDate);
      if (!isNaN(d.getTime())) {
        setCurrentYear(d.getFullYear());
        setCurrentMonth(d.getMonth());
      }
    }
  }, [propStartDate, propEndDate]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDaySelect = (dayNum: number) => {
    const selectedDateStr = formatYYYYMMDD(currentYear, currentMonth, dayNum);
    if (!tempStart || activeTarget === "start") {
      setTempStart(selectedDateStr);
      if (tempEnd && selectedDateStr > tempEnd) {
        setTempEnd("");
      }
      setActiveTarget("end");
    } else {
      if (selectedDateStr < tempStart) {
        setTempStart(selectedDateStr);
        setTempEnd("");
        setActiveTarget("end");
      } else {
        setTempEnd(selectedDateStr);
      }
    }
  };

  const handleApply = () => {
    onChangeRange?.({ startDate: tempStart, endDate: tempEnd });
    setOpen(false);
  };

  const handlePreset = (preset: "today" | "last7" | "thisMonth" | "clear") => {
    const now = new Date();
    if (preset === "today") {
      const todayStr = formatYYYYMMDD(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      setTempStart(todayStr);
      setTempEnd(todayStr);
    } else if (preset === "last7") {
      const endStr = formatYYYYMMDD(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      const past = new Date(now);
      past.setDate(past.getDate() - 6);
      const startStr = formatYYYYMMDD(
        past.getFullYear(),
        past.getMonth(),
        past.getDate()
      );
      setTempStart(startStr);
      setTempEnd(endStr);
    } else if (preset === "thisMonth") {
      const startStr = formatYYYYMMDD(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0
      ).getDate();
      const endStr = formatYYYYMMDD(now.getFullYear(), now.getMonth(), lastDay);
      setTempStart(startStr);
      setTempEnd(endStr);
    } else if (preset === "clear") {
      setTempStart("");
      setTempEnd("");
      setActiveTarget("start");
      setCurrentYear(now.getFullYear());
      setCurrentMonth(now.getMonth());
      onChangeRange?.({ startDate: "", endDate: "" });
    }
  };

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDayIndex = new Date(currentYear, currentMonth, 1).getDay();
  const prevMonthDays = new Date(currentYear, currentMonth, 0).getDate();

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const todayStr = formatYYYYMMDD(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );

  const totalDays = calculateDays(tempStart, tempEnd);

  return (
    <div className={`relative w-full max-w-[360px] pt-1.5 ${open ? "z-[300]" : ""} ${className}`} ref={ref}>
      {/* ── Combined Single Trigger Input Bar for Start & Exp Date ── */}
      <div
        onClick={() => isEditable && !disabled && setOpen(!open)}
        className={`relative w-full rounded-lg pt-3.5 pb-2.5 px-3.5 outline-none text-xs bg-yellow-50 border transition-all duration-200 cursor-pointer flex items-center justify-between gap-2 text-[#1E1E1E] ${
          open
            ? "border-[#FBD037] ring-2 ring-[#FBD037]/30"
            : startDateError || endDateError
            ? "border-red-500"
            : "border-[#FBD037]"
        } ${!isEditable || disabled ? "opacity-70 bg-gray-100 cursor-not-allowed" : ""}`}
      >
        <div className="flex items-center justify-around w-full text-xs text-[#1E1E1E] whitespace-nowrap overflow-hidden">
          {/* Start Date */}
          <div className="flex items-center gap-1.5 font-medium whitespace-nowrap">
            <span>{propStartDate || placeholder}</span>
            <IconCalendarWeek size={15} className="text-[#212121] shrink-0" />
          </div>

          {/* Divider */}
          <span className="h-4 w-[1px] bg-gray-300 mx-2 inline-block shrink-0" />

          {/* Exp Date */}
          <div className="flex items-center gap-1.5 font-medium whitespace-nowrap">
            <span>{propEndDate || placeholder}</span>
            <IconCalendarWeek size={15} className="text-[#212121] shrink-0" />
          </div>
        </div>

        {/* Animated Floating Label */}
        {title && (
          <label
            className={`absolute pointer-events-none transition-all duration-200 ease-in-out select-none rounded-md -top-2.5 left-2.5 text-[11px] font-semibold bg-yellow-50 z-10 px-1.5 ${
              startDateError || endDateError
                ? "!text-red-500"
                : "!text-black font-medium"
            }`}
          >
            {title}
          </label>
        )}
      </div>

      {/* ── COMPACT PREMIUM DATE RANGE UI DROPDOWN ── */}
      {open && isEditable && !disabled && (
        <div
          ref={dropdownRef}
          style={{
            transform: translateX ? `translateX(${translateX}px)` : undefined,
          }}
          className={`absolute z-[350] top-full mt-1.5 ${
            effectiveAlign === "right" ? "right-0" : "left-0"
          }`}
        >
          <div className="bg-white rounded-2xl border border-gray-200 shadow-[0_20px_60px_rgba(0,0,0,0.25)] p-2.5 w-[355px] sm:w-[365px] max-w-[calc(100vw-24px)] animate-in fade-in slide-in-from-top-2 select-none">
          {/* Top Presets & Header Action Bar */}
          <div className="flex items-center justify-between gap-1 pb-2 mb-2 border-b border-gray-100">
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => handlePreset("today")}
                className="px-1.5 py-0.5 rounded-md border border-gray-200 bg-white hover:border-[#FBD037] hover:bg-yellow-50 text-[10px] font-bold text-gray-700 transition-all cursor-pointer whitespace-nowrap shrink-0"
              >
                Today
              </button>
              <button
                type="button"
                onClick={() => handlePreset("last7")}
                className="px-1.5 py-0.5 rounded-md border border-gray-200 bg-white hover:border-[#FBD037] hover:bg-yellow-50 text-[10px] font-bold text-gray-700 transition-all cursor-pointer whitespace-nowrap shrink-0"
              >
                Last 7 Days
              </button>
              <button
                type="button"
                onClick={() => handlePreset("thisMonth")}
                className="px-1.5 py-0.5 rounded-md border border-gray-200 bg-white hover:border-[#FBD037] hover:bg-yellow-50 text-[10px] font-bold text-gray-700 transition-all cursor-pointer whitespace-nowrap shrink-0"
              >
                This Month
              </button>
              <button
                type="button"
                onClick={() => handlePreset("clear")}
                className="px-1.5 py-0.5 rounded-md border border-gray-200 bg-white hover:border-red-300 hover:bg-red-50 text-[10px] font-bold text-gray-500 hover:text-red-600 transition-all cursor-pointer flex items-center gap-0.5 whitespace-nowrap shrink-0"
              >
                <IconRefresh size={11} /> Clear
              </button>
            </div>

            <button
              type="button"
              onClick={handleApply}
              className="bg-[#FBD037] hover:bg-yellow-400 text-[#212121] font-extrabold text-[10px] py-0.5 px-2.5 rounded-md shadow-xs active:scale-95 transition-all flex items-center gap-0.5 cursor-pointer shrink-0 whitespace-nowrap"
            >
              <IconCheck size={12} /> Apply Range
            </button>
          </div>

          {/* Body: 2-Column Layout (Summary Panel Left + Calendar Right) */}
          <div className="grid grid-cols-12 gap-2.5 items-stretch">
            {/* Left Summary Sidebar (SELECTED RANGE) */}
            <div className="col-span-4 bg-gradient-to-b from-yellow-50/90 to-amber-50/40 rounded-lg p-2 border border-amber-200/50 flex flex-col justify-between items-center text-center">
              <div className="w-full flex flex-col items-center">
                <div className="w-8 h-8 rounded-lg bg-white shadow-xs border border-amber-200/80 flex items-center justify-center text-[#B47814] mb-1.5 mt-0.5">
                  <IconCalendarWeek size={16} />
                </div>
                <span className="text-[8px] font-extrabold uppercase tracking-wider text-gray-400 block mb-1.5">
                  SELECTED RANGE
                </span>

                {/* Start Date */}
                <div
                  onClick={() => setActiveTarget("start")}
                  className={`w-full py-1 px-1.5 rounded-lg border transition-all cursor-pointer ${
                    activeTarget === "start"
                      ? "bg-white border-[#FBD037] ring-1 ring-[#FBD037]/30 shadow-xs"
                      : "bg-white/60 border-transparent hover:bg-white"
                  }`}
                >
                  <span className="text-[7px] font-extrabold uppercase text-gray-400 block leading-tight">
                    Start Date
                  </span>
                  <strong className="text-[11px] font-bold text-[#212121] truncate block leading-tight">
                    {formatDateDisplay(tempStart)}
                  </strong>
                </div>

                {/* Arrow */}
                <div className="text-amber-500 font-bold my-0.5 text-[10px]">↓</div>

                {/* End Date */}
                <div
                  onClick={() => setActiveTarget("end")}
                  className={`w-full py-1 px-1.5 rounded-lg border transition-all cursor-pointer ${
                    activeTarget === "end"
                      ? "bg-white border-[#FBD037] ring-1 ring-[#FBD037]/30 shadow-xs"
                      : "bg-white/60 border-transparent hover:bg-white"
                  }`}
                >
                  <span className="text-[7px] font-extrabold uppercase text-gray-400 block leading-tight">
                    Exp Date
                  </span>
                  <strong className="text-[11px] font-bold text-[#212121] truncate block leading-tight">
                    {formatDateDisplay(tempEnd)}
                  </strong>
                </div>
              </div>

              {/* Total Duration Badge */}
              <div className="mt-2 pt-1.5 border-t border-amber-200/50 w-full">
                <span className="text-[10px] font-extrabold text-[#B47814] bg-white px-2 py-0.5 rounded-full border border-amber-200/80 shadow-2xs inline-block">
                  {totalDays} Days
                </span>
              </div>
            </div>

            {/* Right Calendar Section */}
            <div className="col-span-8 flex flex-col justify-between">
              {/* Calendar Month/Year Header (Combined Month & Year in 1 container) */}
              <div className="flex items-center justify-between pb-1.5 mb-1 border-b border-gray-100 w-full">
                <button
                  type="button"
                  onClick={handlePrevMonth}
                  className="p-1 rounded-full text-gray-600 hover:bg-yellow-100/80 hover:text-black transition-all active:scale-95 shrink-0 cursor-pointer"
                >
                  <IconChevronLeft size={15} />
                </button>

                {/* Single Combined Month & Year Container */}
                <div className="flex items-center justify-center bg-white border border-gray-200 rounded-lg px-2 py-0.5 shadow-2xs hover:border-[#FBD037] transition-all">
                  <CustomSelect
                    value={currentMonth}
                    options={MONTH_NAMES.map((mName, idx) => ({
                      label: mName,
                      value: idx,
                    }))}
                    onChange={(val) => setCurrentMonth(Number(val))}
                    className="min-w-[70px]"
                    buttonClassName="border-0 bg-transparent py-0 px-1 text-[11px] font-extrabold text-[#212121] shadow-none"
                    menuClassName="min-w-[95px]"
                  />
                  <span className="text-gray-400 font-bold text-[11px] mx-0.5">•</span>
                  <CustomSelect
                    value={currentYear}
                    options={ALL_YEARS.map((yr) => ({
                      label: String(yr),
                      value: yr,
                    }))}
                    onChange={(val) => setCurrentYear(Number(val))}
                    className="min-w-[50px]"
                    buttonClassName="border-0 bg-transparent py-0 px-1 text-[11px] font-extrabold text-[#212121] shadow-none"
                    menuClassName="min-w-[62px]"
                  />
                </div>

                <button
                  type="button"
                  onClick={handleNextMonth}
                  className="p-1 rounded-full text-gray-600 hover:bg-yellow-100/80 hover:text-black transition-all active:scale-95 shrink-0 cursor-pointer"
                >
                  <IconChevronRight size={15} />
                </button>
              </div>

              {/* Days of Week */}
              <div className="grid grid-cols-7 text-center mb-0.5">
                {DAYS_OF_WEEK.map((d) => (
                  <span
                    key={d}
                    className="text-[9px] font-bold text-gray-400 uppercase"
                  >
                    {d}
                  </span>
                ))}
              </div>

              {/* Days Grid with Rounded Pill Range Selection Caps */}
              <div className="grid grid-cols-7 text-center">
                {/* Overflow Previous Month Days */}
                {Array.from({ length: firstDayIndex }).map((_, idx) => (
                  <div
                    key={`prev-${idx}`}
                    className="aspect-square flex items-center justify-center text-[11px] text-gray-300 font-light"
                  >
                    {prevMonthDays - firstDayIndex + idx + 1}
                  </div>
                ))}

                {/* Current Month Days */}
                {Array.from({ length: daysInMonth }).map((_, idx) => {
                  const dayNum = idx + 1;
                  const dStr = formatYYYYMMDD(
                    currentYear,
                    currentMonth,
                    dayNum
                  );
                  const isStart = dStr === tempStart;
                  const isEnd = dStr === tempEnd;
                  const isInRange =
                    tempStart && tempEnd && dStr > tempStart && dStr < tempEnd;
                  const isToday = dStr === todayStr;

                  return (
                    <div
                      key={dayNum}
                      className={`py-0.5 ${
                        isStart && isEnd
                          ? "bg-transparent"
                          : isStart
                          ? "bg-gradient-to-r from-transparent to-yellow-100/90"
                          : isEnd
                          ? "bg-gradient-to-l from-transparent to-yellow-100/90"
                          : isInRange
                          ? "bg-yellow-100/90"
                          : "bg-transparent"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => handleDaySelect(dayNum)}
                        className={`w-full aspect-square flex items-center justify-center text-[11px] font-bold transition-all duration-150 cursor-pointer ${
                          isStart && isEnd
                            ? "bg-[#FBD037] text-[#212121] rounded-full shadow-md scale-105"
                            : isStart
                            ? "bg-[#FBD037] text-[#212121] rounded-l-full shadow-md scale-105"
                            : isEnd
                            ? "bg-[#FBD037] text-[#212121] rounded-r-full shadow-md scale-105"
                            : isInRange
                            ? "bg-yellow-100/90 text-[#212121] rounded-none"
                            : isToday
                            ? "border border-[#FBD037] text-slate-900 bg-yellow-50 rounded-full"
                            : "hover:bg-yellow-100/70 text-[#212121] rounded-full"
                        }`}
                      >
                        {dayNum}
                      </button>
                    </div>
                  );
                })}
              </div>

              {/* Bottom Quick Row */}
              <div className="mt-1.5 pt-1 border-t border-gray-100 flex items-center justify-between text-[10px] font-bold text-gray-500">
                {/* <span>Select range</span> */}
                {/* <span className="text-[10px] text-amber-700">
                  {tempStart && tempEnd
                    ? `${tempStart} → ${tempEnd}`
                    : tempStart
                    ? `From ${tempStart}`
                    : "No range selected"}
                </span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </div>
  );
};

export default PremiumDateRangePicker;
